export default "__VITE_ASSET__B54k9tnk__"